import { LoadIdView } from '../../../../models';

export class ShipmentLoadDemurrageAndDetentionInfoLoad {
  public static readonly type = '[ShipmentLoadDemurrageAndDetentionInfo] Load Info';
  constructor(public payload: LoadIdView) {}
}

export class ShipmentLoadDemurrageAndDetentionInfoSetInitialState {
  public static readonly type = '[ShipmentLoadDemurrageAndDetentionInfo] Set Initial State';
}
